<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <el-form :model="state.model" ref="formDom" class="infoForm">
        <el-form-item label="状态">
          <el-switch
            v-model="state.model.status"
            inline-prompt
            active-text="正常"
            active-color="#1e90ff"
            inactive-text="停用"
            inactive-color="#f00"
            :active-value="1"
            :inactive-value="0"
            style="--el-switch-off-color: #f00"
          />
        </el-form-item>
        <el-form-item
          label="供应商名称"
          prop="name"
          :rules="[
            {
              required: true,
              message: '请填写供应商名称',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="state.model.name"></el-input>
        </el-form-item>
        <el-form-item
          label="统一社会信用代码"
          prop="unified_social_credit_identifier"
          :rules="[
            {
              required: true,
              message: '请填写统一社会信用代码',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="state.model.unified_social_credit_identifier"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="业务员"
          prop="belonger_id"
          :rules="[
            {
              required: true,
              message: '请选业务员',
              trigger: 'blur',
            },
          ]"
        >
          <el-tree-select
            v-model="state.model.belonger_id"
            :props="{
              value: 'id',
              label: 'name',
              class: 'belonger-tree-class',
            }"
            placeholder="业务员"
            :data="state.admin_data"
            default-expand-all
            filterable
            clearable
            @current-change="onBelongerChange"
          >
            <template #default="{ data }">
              <el-icon :size="16" v-if="data.type == 0"><UserFilled /></el-icon>
              <el-icon :size="16" v-else><User /></el-icon>
              <span style="margin-left: 3px">{{ data.name }}</span>
            </template>
          </el-tree-select>
          <!-- <el-select
            v-model="state.model.belonger_id"
            placeholder="--选择业务员--"
            @change="onBelongerChange"
          >
            <el-option
              v-for="item in state.belongerData"
              :key="item.id"
              :label="
                (item.department_name ? '(' + item.department_name + ')' : '') +
                item.name
              "
              :value="item.id"
            />
            <template #footer>
              <el-button size="small" @click="onLoadAdmin()"> 刷新 </el-button>
            </template>
          </el-select> -->
        </el-form-item>
        <el-form-item
          label="所属地区"
          prop="district"
          :rules="[
            {
              required: true,
              message: '请填写联系人',
              trigger: 'blur',
            },
          ]"
        >
          <el-cascader
            v-model="state.model.area"
            :options="state.areaData"
            :props="{ label: 'name', value: 'name' }"
            placeholder="--所属地区--"
            style="width: 100%"
            clearable
            filterable
            @change="onAreaChange"
          />
        </el-form-item>
        <el-form-item
          label="所在地址"
          prop="address"
          :rules="[
            {
              required: true,
              message: '请填写所在地址',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="state.model.address"></el-input>
        </el-form-item>
        <el-form-item
          label="联系人"
          prop="contact_name"
          :rules="[
            {
              required: true,
              message: '请填写联系人',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="state.model.contact_name"></el-input>
        </el-form-item>
        <el-form-item
          label="职位"
          prop="contact_job"
          :rules="[
            {
              required: true,
              message: '请填写职位',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="state.model.contact_job"> </el-input>
        </el-form-item>
        <el-form-item
          label="联系电话"
          prop="contact_phone"
          :rules="[
            {
              required: true,
              message: '请填写联系电话',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="state.model.contact_phone"></el-input>
        </el-form-item>
      </el-form>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { data_areacode_tree } from "@/http/data";
import { supplier_add, supplier_detail, supplier_edit } from "@/http/supplier";
import { post_response } from "@/utils/qFormat";
import { ElMessage } from "element-plus";
import { admin_cascader } from "@/utils/qFormat";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
        sex: 0,
        property: 0,
      },
    });
    onMounted(() => {
      onLoadAdmin();
      onLoadAreaCode();

      if (props.id) {
        supplier_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data.data;
            if (state.model.district) {
              state.model.area = [
                state.model.province,
                state.model.city,
                state.model.district,
              ];
            }
          }
        });
      }
    });

    //加载业务员
    const onLoadAdmin = () => {
      admin_cascader().then((res) => {
        state.admin_data = res;
      });
    };

    //业务员改变事件需要获取其部门id
    const onBelongerChange = (item) => {
      // const item = state.belongerData.find((w) => w.id == value);
      // state.model.belonger_department_id = item.department_id;
      state.model.belonger_department_id = item.pid;
    };

    const onLoadAreaCode = () => {
      data_areacode_tree().then((res) => {
        if (res.status == 200) state.areaData = res.data.data?.list;
      });
    };

    const onAreaChange = (value) => {
      if (value.length == 3) {
        state.model.province = value[0];
        state.model.city = value[1];
        state.model.district = value[2];
      }
    };

    const onSubmit = () => {
      formDom.value.validate((valid, rules) => {
        if (valid) {
          if (props.id) {
            supplier_edit(state.model).then((res) => {
              post_response(res, emit);
            });
          } else {
            supplier_add(state.model).then((res) => {
              post_response(res, emit);
            });
          }
        } else {
          ElMessage({
            type: "warning",
            grouping: true,
            message: rules[Object.keys(rules)[0]][0]?.message,
          });
        }
      });
    };
    return {
      state,
      props,
      formDom,
      onSubmit,
      onLoadAdmin,
      onAreaChange,
      onBelongerChange,
    };
  },
};
</script>
<style scoped lang="less"></style>
